/**
 * 회원가입 정보입력 (/m/signup/form) — 개인(본인인증 값 채움)·기업·머큐리 회원 폼, jquery-validation
 * ($j.Pages.Mobile.SignupForm / body data-page-name="SignupForm")
 */
export default class SignupForm {
    initialize() {
        // 저장은 ajax 로만 — 엔터·jquery-validation 이 폼을 그대로 내보내지 않게
        $('#inputform').on('submit', (e) => e.preventDefault());

        const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');   // 서버 값 (#page-data)

        const mb = D.mb;   // 본인인증 정보 (개인회원). 없으면 기업·머큐리 회원
        const isPersonal = !!mb;
        const isApp = !!window.App;

        // 검사 대상 칸 (가입하기 버튼 활성화 판정·저장 전 전체 표시에 쓴다)
        const FIELDS = { mem_id: '아이디', mem_pwd: '비밀번호', mem_pwd2: '비밀번호 확인', mem_name: '이름', mem_email: '이메일' };

        let v = null;               // jquery-validate 인스턴스
        let quiet = true;           // 최초 전체검사(버튼 상태 계산용) 동안에는 문구를 붙이지 않는다
        const touched = {};         // 손댄 칸만 오류문구를 보여준다
        let validateId = null;      // 아이디 원격검사 디바운스
        let idUnlocked = false;     // 중복이라 직접 입력을 열어 준 상태
        let saving = false;

        $(function () {
            initId();
            initPassword();
            initEmailDomain();
            initValidator();

            $('#next-button').on('click', saveData);
            window.addEventListener('pageshow', function (e) {
                if (e.persisted) { saving = false; updateNextButton(); }
            });
        });

        /* ───────────── 아이디 ───────────── */

        function initId() {
            const $id = $('#mem_id');
            $j.Common.Form.registerPhoneHandler('mem_id');

            if (isPersonal) {
                $id.val($j.Common.Util.phoneNumber(String(mb.userPhone || ''))).prop('readonly', true);
                setIdHelp('본인인증한 휴대폰 번호가 아이디가 돼요.');
            } else if (isApp) {
                $id.prop('readonly', true).attr('placeholder', '자동입력을 눌러 주세요');
                $('#mem_id_auto_btn').prop('hidden', false).on('click', requestPhoneNumberByAndroid);
                setIdHelp('이 휴대폰의 번호를 가져와 아이디로 써요.');
                // 앱이 폰번호를 회신한다 (getPhoneNumber → callbackPhoneNumber)
                $j.Common.EventBus.on(G5['NS'], 'app:phone:number', function (e, data) {
                    applyPhoneNumber(data && data.pno);
                });
            } else {
                setIdHelp('아이디로 쓸 휴대폰 번호를 입력해 주세요.');
            }
        }

        function setIdHelp(text) {
            $('#mem_id_help').text(text);
        }

        /** 아이디가 이미 쓰이고 있으면 그때만 직접 입력을 연다 */
        function unlockIdForDuplicate() {
            const $id = $('#mem_id');
            if (!$id.prop('readonly')) return;
            touched.mem_id = true;
            idUnlocked = true;
            $id.prop('readonly', false).attr('placeholder', '010-0000-0000');
            setIdHelp('이미 가입된 번호예요. 아이디로 쓸 다른 휴대폰 번호를 직접 입력해 주세요.');
        }

        function requestPhoneNumberByAndroid() {
            $j.Common.Util.swalert('이 휴대폰의 번호를 가져와 아이디로 쓸게요.\n허용하지 않으면 자동입력을 쓸 수 없어요.', function () {
                // 앱이 거부(ok:0)하면 번호를 읽을 수 없는 앱이다 — 아이폰은 원리상 못 읽고, 옛 안드로이드 앱은 액션을 모른다.
                // 업데이트를 권하지 않고 직접 입력을 연다
                if (!$j.F.App.getPhoneNumber()) unlockIdForManual();
            }, ['허용', '거부'], function () {});
        }

        /** 자동입력을 쓸 수 없는 앱이면 직접 입력으로 돌린다 */
        function unlockIdForManual() {
            idUnlocked = true;   // 검사가 통과하면 안내를 '입력한 번호를 아이디로 써요' 로 바꾼다
            $('#mem_id').prop('readonly', false).attr('placeholder', '010-0000-0000').trigger('focus');
            $('#mem_id_auto_btn').prop('hidden', true);
            setIdHelp('이 휴대폰에서는 번호를 자동으로 가져올 수 없어요. 아이디로 쓸 휴대폰 번호를 직접 입력해 주세요.');
        }

        /** 앱이 회신한 폰번호를 아이디칸에 반영 */
        function applyPhoneNumber(pno) {
            pno = String(pno || '');
            if (pno.indexOf('+82') === 0) pno = '0' + pno.slice(3);   // +8210… → 010…
            const el = document.getElementById('mem_id');
            el.value = $j.Common.Util.phoneNumber(pno.replace(/[^\d]/g, ''));
            touched.mem_id = true;
            checkElementValid(el);
        }

        /* ───────────── 비밀번호 ───────────── */

        function initPassword() {
            $('.sg-eye').on('click', function () {
                const $inp = $(this).siblings('input');
                const show = $inp.attr('type') === 'password';
                $inp.attr('type', show ? 'text' : 'password');
                $(this).attr({ 'aria-pressed': String(show), 'aria-label': show ? '비밀번호 숨기기' : '비밀번호 보기' });
            });

            $('#mem_pwd').on('input', function () {
                renderPasswordRules();
                // 비밀번호를 고치면 '확인' 칸의 일치 여부도 다시 본다
                if (v && $('#mem_pwd2').val()) { v.element('#mem_pwd2'); updateNextButton(); }
            });
            renderPasswordRules();
        }

        function renderPasswordRules() {
            const val = $('#mem_pwd').val() || '';
            const ok = { alpha: /[a-z]/i.test(val), digit: /\d/.test(val), length: val.length >= 8 };
            $('#pw-rules .sg-rule').each(function () {
                this.classList.toggle('is-ok', !!ok[this.dataset.rule]);
            });
        }

        /* ───────────── 이메일 ───────────── */

        function initEmailDomain() {
            const $email = $('#mem_email');
            const $domain = $('#mem_email_domain');
            const domains = $domain.find('option').toArray().map((o) => o.value).filter(Boolean);

            $domain.on('change', function () {
                const domain = this.value;
                if (!domain) return;
                const el = $email[0];
                const local = (el.value || '').split('@')[0].trim();
                el.value = local + '@' + domain;
                if (local) {
                    touched.mem_email = true;
                } else {
                    el.focus();   // 아이디를 아직 안 적었으면 @ 앞에서 이어 치게 한다
                    try { el.setSelectionRange(0, 0); } catch (e) { /* type=email 은 캐럿 지정 불가 */ }
                }
                checkElementValid(el);
            });

            // 타이핑한 도메인이 목록에 있으면 선택상자도 따라온다 (없으면 '직접 입력')
            $email.on('input', function () {
                const domain = ((this.value || '').split('@')[1] || '').trim().toLowerCase();
                $domain.val(domains.includes(domain) ? domain : '');
            });
        }

        /* ───────────── 검증 ───────────── */

        function initValidator() {
            $.validator.addMethod('pwRule', function (value, el) {
                return this.optional(el) || $j.Core.Config.PASSWORD_RE.test(value);
            });
            $.validator.addMethod('phoneId', function (value, el) {
                return this.optional(el) || /^01\d-?\d{3,4}-?\d{4}$/.test(value);
            });

            validateId = $j.Common.Util.debounce(function (el) {
                v.element(el);
                updateNextButton();
            }, 400);

            v = $('#inputform').validate({
                errorElement: 'p',
                errorClass: 'is-error',
                rules: {
                    mem_id: { required: true, phoneId: true, remote: '/m/ajax/member/id/check' },
                    mem_pwd: { required: true, pwRule: true },
                    mem_pwd2: { required: true, equalTo: '#mem_pwd' },
                    mem_name: { required: true, minlength: 2 },
                    // 이메일 필수 — 세금계산서·거래명세표가 이 주소로 나간다
                    mem_email: { required: true, email: true },
                },
                messages: {
                    mem_id: {
                        required: '아이디로 쓸 휴대폰 번호를 입력해 주세요.',
                        phoneId: '휴대폰 번호를 끝까지 입력해 주세요.',
                        remote: '이미 사용 중인 아이디예요.',
                    },
                    mem_pwd: {
                        required: '비밀번호를 입력해 주세요.',
                        pwRule: $j.Core.Config.PASSWORD_MSG,
                    },
                    mem_pwd2: {
                        required: '비밀번호를 한 번 더 입력해 주세요.',
                        equalTo: '비밀번호가 일치하지 않아요.',
                    },
                    mem_name: {
                        required: '이름을 입력해 주세요.',
                        minlength: '이름은 2자 이상 입력해 주세요.',
                    },
                    mem_email: {
                        required: '이메일을 입력해 주세요.',
                        email: '이메일 형식이 올바르지 않아요.',
                    },
                },
                // 손댄 칸만 문구를 붙인다. 잠긴 아이디칸은 사용자가 손댈 수 없으니 바로 보여준다(중복 안내)
                errorPlacement: function (error, element) {
                    const name = element.attr('name');
                    if (quiet || !(touched[name] || element.prop('readonly'))) {
                        error.hide();
                        return;
                    }
                    error.addClass('sg-err');
                    const $anchor = element.closest('.sg-field').find('.sg-row, .sg-pw').first();
                    error.insertAfter($anchor.length ? $anchor : element);
                },
                highlight: function (el) {
                    if (!quiet && (touched[el.name] || el.readOnly)) $(el).addClass('is-error');
                },
                unhighlight: function (el) {
                    $(el).removeClass('is-error');
                },
                onkeyup: function (el) { checkElementValid(el); },
                onfocusout: function (el) { touched[el.name] = true; checkElementValid(el); },
                onclick: false,
            });

            // 원격검사(아이디 중복)가 끝나는 순간 — 중복이면 잠긴 아이디칸을 열고, 버튼 상태를 다시 계산한다.
            // (응답이 늦게 와도 다시 부르는 곳이 없으면 폼이 다 맞아도 버튼이 꺼진 채로 남는다)
            const stopRequest = v.stopRequest;
            v.stopRequest = function (element, valid) {
                stopRequest.call(this, element, valid);
                if (element && element.name === 'mem_id') {
                    if (!valid) unlockIdForDuplicate();
                    else if (idUnlocked) setIdHelp('입력한 번호를 아이디로 써요.');   // '이미 가입된 번호' 안내가 남지 않게
                }
                updateNextButton();
            };

            $('#inputform').valid();   // 버튼 상태 계산용 전체검사 (문구는 붙이지 않는다)
            quiet = false;
            updateNextButton();
        }

        function checkElementValid(el) {
            if (!v || !el.name) return;
            if (el.name === 'mem_id') {
                validateId(el);
            } else {
                v.element(el);
            }
            updateNextButton();
        }

        function updateNextButton() {
            if (!v) return;
            const pending = v.pendingRequest > 0;
            const bad = Object.keys(FIELDS).filter((n) => v.invalid[n]);
            $('#next-button').prop('disabled', pending || bad.length > 0 || saving);
        }

        /* ───────────── 저장 ───────────── */

        function saveData() {
            if (saving || !v) return;

            Object.keys(FIELDS).forEach((n) => { touched[n] = true; });
            if (!$('#inputform').valid() || v.pendingRequest > 0) {
                updateNextButton();
                return;
            }

            saving = true;
            $('#next-button').prop('disabled', true).addClass('is-loading');

            const done = function () {
                saving = false;
                $('#next-button').removeClass('is-loading');
                updateNextButton();
            };

            $.ajax({ url: '/m/ajax/member/join', type: 'post', dataType: 'json', data: $('#inputform').serialize() })
                .done(function (res) {
                    if (res && res.result) {
                        location.replace('/m/signup/complete');
                        return;
                    }
                    if (res && res.code === 'SESSION') {
                        $j.Common.Util.swalert(res.message, function () { location.replace('/m/signup/agreement'); });
                        return;
                    }
                    $j.Common.Util.swalert((res && res.message) || '가입하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                    done();
                })
                .fail(function () {
                    // 입력한 값을 잃지 않게 화면에 머문다 (예전에는 로그인 화면으로 보냈다)
                    $j.Common.Util.swalert('네트워크 오류로 가입하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                    done();
                });
        }
    }
}
